import {
    ImageBackground,
    Keyboard,
    Platform,
    Pressable,
    Text,
    TextInput, TouchableWithoutFeedback,
    View
} from "react-native";
import React, {useState} from "react";

import {styles} from "../common/styles";
import {RECOVER_PASSWORD_URL} from "../common/constants";
import {i18n} from "../common/localization";
import {InfoModal} from "../common/InfoModal";
import {ActivityIndicatorView} from "../common/ActivityIndicatorView";
import {KeyboardAvoidingViewWrapper} from "../common/KeyboardAvoidingViewWrapper";
import {FlagHeader} from "../common/FlagHeader";

import bg from "../assets/main-bg.jpg";
import {ShownWithKeyboardView} from "../common/ShownWithKeyboardView";

export const RecoveryPassword = ({ navigation }) => {
    // E-mail
    const [login, setLogin] = React.useState("");

    // Error modal
    const [infoModalVisible, setInfoModalVisible] = useState(false);
    const [infoModalText, setInfoModalText] = useState("");
    const [infoModalIsError, setInfoModalIsError] = useState(false);

    // Errors
    const [errors, setErrors] = useState({});

    // Activity indicator
    const [isLoading, setIsLoading] = React.useState(false);

    // Sends the form
    function onPressRecover() {
        if (login.trim().length === 0) {
            setErrors({ ...errors, login: "Incorrect login" });
            return;
        } else {
            setErrors({ ...errors, login: undefined });
        }

        setIsLoading(true);

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        fetch(RECOVER_PASSWORD_URL + "/" + login, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setIsLoading(false);
                // TODO: Another possible statuses?
                if (result["status"] === 400 || result["status"] === 500) {
                    showDefaultError();
                } else if (result["Message"] !== "OK") {
                    showNoSuchEmailError();
                } else {
                    clearForm();
                    showOkModal();
                }
            })
            .catch(() => {
                setIsLoading(false);
                showDefaultError();
            });
    }

    // Closes results modal
    function onCloseError() {
        setInfoModalVisible(false);
    }

    function clearForm() {
        setLogin("");
        setErrors({});
    }

    function showDefaultError() {
        setInfoModalText("");
        setInfoModalIsError(true);
        setInfoModalVisible(true);
    }

    function showNoSuchEmailError() {
        setInfoModalText(i18n.t("loginDoesNotExist"));
        setInfoModalIsError(true);
        setInfoModalVisible(true);
    }

    function showOkModal() {
        setInfoModalText(i18n.t("recoverPasswordOkText"));
        setInfoModalIsError(false);
        setInfoModalVisible(true);
    }

    return (
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
            <View style={styles.container}>
                <ImageBackground source={bg} resizeMode="cover" style={styles.bgImageContainer}>
                    <KeyboardAvoidingViewWrapper style={styles.login.mainViewContainer}>
                        <View style={{flex: 1, justifyContent: "center"}}>
                            <FlagHeader/>
                            { Platform.OS === 'ios' && <ShownWithKeyboardView /> }
                            <View>
                                <Text style={styles.login.recoverPasswordText}>{i18n.t("recoverPasswordText")}</Text>
                                <View style={styles.login.inputContainer}>
                                    <TextInput
                                        style={styles.login.input}
                                        placeholder={i18n.t("login")}
                                        placeholderTextColor="white"
                                        cursorColor="white"
                                        color="white"
                                        onChangeText={(value) => {
                                            setLogin(value)
                                            setErrors({ ...errors, login: undefined })
                                        }}
                                        value={login}
                                        autoComplete="username"
                                        autoCapitalize="none"
                                        autoCorrect={false}
                                        keyboardType={"default"}
                                    />
                                    { errors.login && <Text style={styles.errorText}>{i18n.t("incorrectLogin")}</Text> }
                                </View>
                                <View style={styles.login.buttonContainer}>
                                    <Pressable onPress={onPressRecover} color={"none"} style={{...styles.login.button, alignItems: "center"}}>
                                        <Text style={styles.buttonText}>{i18n.t("recoverPassword")}</Text>
                                    </Pressable>
                                </View>
                                <View style={{...styles.buttonContainer, marginTop: 29}}>
                                    <Pressable onPress={() => navigation.goBack()} color={"none"} style={{...styles.button, backgroundColor: "none"}}>
                                        <Text style={styles.buttonText}>{i18n.t("cancel")}</Text>
                                    </Pressable>
                                </View>
                            </View>
                        </View>
                    </KeyboardAvoidingViewWrapper>
                </ImageBackground>
                <ActivityIndicatorView isVisible={isLoading} />
                <InfoModal
                    visible={infoModalVisible}
                    text={infoModalText}
                    onPressClose={onCloseError}
                    isError={infoModalIsError}
                />
            </View>
        </TouchableWithoutFeedback>
    )
}
